// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__I5n1-","palleteItem":"styles_palleteItem__TvVYT"};